import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

interface DraggablePostItProps {
    id: string;
    content: string;
    color?: string;
}

export const DraggablePostIt: React.FC<DraggablePostItProps> = ({ id, content, color = '#fef08a' }) => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: id,
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        backgroundColor: color,
        zIndex: isDragging ? 50 : 1,
        touchAction: 'none',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...listeners}
            {...attributes}
            className={`
        post-it w-16 h-16 shadow-md p-2 flex items-center justify-center text-center text-xs font-handwriting
        cursor-move hover:scale-105 transition-transform
        ${isDragging ? 'opacity-80 shadow-xl rotate-3' : 'rotate-1'}
      `}
        >
            <span className="font-semibold text-gray-800 break-words leading-tight select-none">
                {content}
            </span>
        </div>
    );
};
